<app-text id="shared-chip-toggler-heading-text" [textStyleType]="'overline'">{{
  headingText
}}</app-text>
<div
  class="chip-toggler-wrapper"
  [class.tab-switcher]="isTabSwitcher"
  [ngClass]="chipContentClassNames"
  id="shared-chip-toggler-wrapper"
  *ngIf="chipData.length === 2; else noChips"
>
  <app-chip
    *ngFor="let chip of chipData"
    [id]="'shared-chip-toggler-' + chip.id"
    [predefinedChipStylingClassName]="'filter-chip'"
    [isFilterChipActive]="isChipActive(chip.id)"
    [chipId]="chip.id"
    [iconName]="chip?.chipIconName || ''"
    [showIcon]="chip?.showIcon || false"
    [iconSize]="chip?.chipIconSize || ''"
    [isHoverable]="true"
    [ngStyle]="customClass"
    (chipClickEvent)="onChipClickHandler($event)"
    [disableFilterChip]="disableChipToggler"
    [class]="'shared-chip-toggler-' + chip.id"
    >{{ chip.chipTextKey | translate }}</app-chip
  >
</div>
<ng-template #noChips>
  <div class="no-chip-text" id="chip-toggler-no-chip-text-wrapper">
    <app-text [textStyleType]="'overline'" id="chip-toggler-no-chip-text">{{
      'guardhouse.filerChip.noFilterChipText' | translate
    }}</app-text>
  </div>
</ng-template>
